import { createContext } from "react";

export const settingContext = createContext(undefined as any);

